import styled from 'styled-components';

import { Skeleton as CoreSkeleton } from 'atoms/animations/Skeleton';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';

export const Root = styled(Vertical).attrs({ gap: 0.5, center: true })`
  position: relative;
  scroll-snap-align: center;
  justify-content: stretch;
  text-align: center;
`;
export const Label = styled(LabelS).attrs({ as: 'p' })`
  max-width: 100px;
`;
export const EllipsisLabel = styled(Label)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: unset; /** use the minimum line-height possible without breaking the box sized creating overflows. */
`;

export const PictureWrapper = styled.div`
  position: relative;
  border: 1px solid transparent;
  border-radius: 50%;
  padding: 2px;

  & > img,
  & > svg {
    border-radius: 50%;
    width: 60px;
    height: 60px;
    object-fit: cover;
  }

  &.gradientBorder {
    background-image: linear-gradient(
        90deg,
        var(--c-neutral-100),
        var(--c-neutral-100)
      ),
      var(--c-rivals-gradient-friendlies);
    background-clip: padding-box, border-box;
    background-origin: border-box;
  }
`;

export const IconWrapper = styled(Horizontal).attrs({ gap: 0, center: true })`
  position: absolute;
  bottom: 0;
  right: 0;
  border: 2px solid var(--c-neutral-300);
  width: 22px;
  height: 22px;
  background-color: var(--c-neutral-1000);
  color: var(--c-neutral-100);
  border-radius: 50%;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const Skeleton = styled(CoreSkeleton)`
  width: 100%;
  height: 100%;
`;
